/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function Download() {
  return (
    <>
      <div className="section section-dark gradient-background-claro">
        <Container className="text-center">
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <h2 className="title gradient-title"> Do you want to help the project? </h2>
              <hr style={{ clear: 'both' }} />
              <h5 className="description" style={{ display: 'inline' }} > If you are interested in contacting me, please send an email to </h5>
              <a href="mailto:daniloabella@gmail.com" ><h5 className="description text-info" style={{ display: 'inline' }} > daniloabella@gmail.com</h5></a>
              <h5 className="description" style={{ display: 'inline' }} >
                , I will gladly answer any feedback or comments. If you are a digital artist, do fan-arts or know about sound editing, you can send me your work and I will gladly check it out. In case you are a streamer and you want to share your live with me, I will gladly participate as soon as possible, if I have the chance.
              </h5>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Download;
